import React from "react";
import AssignedWorksheets from "./AssignedWorksheets";

/**
 * The "Assigned to me" tab body inside the Work Sheet page.
 *
 * Thin wrapper so the tab and the standalone page stay one implementation — the assigned-worksheet
 * logic must not be duplicated and drift.
 */
export default function AssignedWorksheetsPanel() {
  return <AssignedWorksheets embedded />;
}
